export default "__VITE_ASSET__ov8nLwcb__"